import { motion } from "framer-motion";
import { useSound } from "../context/SoundContext";
import { Volume2, VolumeX } from "lucide-react";

export const SoundToggle = () => {
  const { soundOn, toggleSound } = useSound();
  return (
    <motion.button
      type="button"
      data-testid="sound-toggle"
      className={`sound-toggle ${soundOn ? "on" : "off"}`}
      whileTap={{ scale: 0.96 }}
      onClick={toggleSound}
    >
      <span className="sound-toggle-left">
        {soundOn ? <Volume2 size={20} strokeWidth={1.5} /> : <VolumeX size={20} strokeWidth={1.5} />}
        <span>Sons</span>
      </span>
      <span className={`sound-pill ${soundOn ? "on" : "off"}`}>
        <span className="sound-knob" />
      </span>
    </motion.button>
  );
};

export default SoundToggle;
